'use client'
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import useSWR from 'swr';

import ArticleShareBar from '../../[locale]/(default)/[id]/components/ArticleShareBar/ArticleShareBar';

import { AddComment, CommentList } from './comments/index';

import Button from '@components/Form/Button';
import Loader from '@components/root/Loader';
import { fetcher } from '@lib/api/fetcher';

export const limit = 100;

type Props = {
  slug: string;
  postId: number;
  canWrite?: boolean;
};
const Comments = ({ slug, postId, canWrite = false }: Props) => {
  const [showCommentEditor, setShowCommentEditor] = useState<boolean>(false);
  const t = useTranslations();
  const { data, error } = useSWR<any>(`/comments/${postId}?limit=${limit}`, fetcher, {
    refreshInterval: 60000,
  });

  const filteredData = (data || [])?.filter(
    (comment) => !['trash', 'spam', 'hold'].includes(comment.status)
  );

  const count = (filteredData?.length || 0) as number;
  const commentsText = t('main.posts.comments', { count: count === limit ? count + '+' : count });

  return (
    <div className="py-5">
      <div className="comments_title">
        <hr className="comments-share-divider" />
        <div className="flex justify-between items-center flex-col sm:flex-row">
          <h2 className="text-premium-900 text-xl my-3">
            {commentsText}
          </h2>
          <div className="flex justify-between items-center sm:gap-6 flex-col sm:flex-row">
            <ArticleShareBar
              slug={slug}
              title={t('main.functionalities.share')}
            />
            {canWrite && !showCommentEditor && (
              <Button
                className='basis-0  my-6 px-3'
                onClick={() => {
                  setShowCommentEditor(true);
                }}
              >
                {t('main.functionalities.comment')}
              </Button>
            )}
          </div>
        </div>
      </div>
      {showCommentEditor && (
        <div className="mt-lg-3 mb-1">
          <AddComment postId={postId} hideAddComment={() => setShowCommentEditor(false)} />
        </div>
      )}
      {filteredData === undefined && error === undefined ? (
        <Loader delay={0} />
      ) : (
        <CommentList data={filteredData} canWrite={canWrite} />
      )}
    </div>
  );
};

export default Comments;
